import { ActionTypes } from './actionTypes';
import type { GeocodeLatLngBatchFailed, GeocodeLatLngBatchRequest, GeocodeLatLngBatchSucceeded } from './actions';

import type { BatchAddress } from '@cobliteam/api-lib';

export const geocodeLatLngBatchRequest = (addresses: string[]): GeocodeLatLngBatchRequest => ({
  type: ActionTypes.GEOCODE_LAT_LNG_BATCH_REQUEST,
  payload: addresses,
});

export const geocodeLatLngBatchSucceeded = (batchAddress: BatchAddress[]): GeocodeLatLngBatchSucceeded => ({
  type: ActionTypes.GEOCODE_LAT_LNG_BATCH_SUCCEEDED,
  payload: batchAddress,
});

export const geocodeLatLngBatchFailed = (): GeocodeLatLngBatchFailed => ({
  type: ActionTypes.GEOCODE_LAT_LNG_BATCH_FAILED,
});
